/* istanbul ignore file */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { GoogleAnalyticsService } from 'src/app/core/services/google-tag-manager.service';
import { IAppPromoSlot } from 'src/app/model/promos/IAppPromo';
import { UtilityService } from '../../../../core/services/utility.service';
import { ChatHandler } from 'src/app/core/handler/chat-handler';
import { ADPResourceService } from 'digital-core';
import { AsappChatService } from '../../../../core/services/asapp-chat.service';

@Component({
  selector: 'app-apptype-promotion-panel',
  templateUrl: './apptype-promotion-panel.component.html',
  styleUrls: ['./apptype-promotion-panel.component.scss'],
})
export class AppTypePromotionPanelComponent implements OnInit {
  @Input() promoSlot: IAppPromoSlot;
  @Input() isPTPO: boolean = false;
  @Input() isDisabledController: boolean;
  @Input() gaName;
  @Input() divider = false;

  @Output() letsChatClicked = new EventEmitter();

  public qrCodeImageUrl: string = '';
  public qrCodeImageAlt: string = '';

  constructor(
    private matDialog: MatDialog,
    public route: ActivatedRoute,
    private utilityService: UtilityService,
    private googleAnalyticsService: GoogleAnalyticsService,
    public resourceService: ADPResourceService,
    private asappChatService: AsappChatService
  ) {}

  ngOnInit() {
    this.qrCodeImageUrl = this.resourceService.getPortalImage(this.promoSlot?.qrCodeImageKey).ImageURL;
    this.qrCodeImageAlt = this.resourceService.getPortalImage(this.promoSlot?.qrCodeImageKey).Caption;
  }

  getResource(name: string, namespace = null) {
    namespace = namespace ? namespace : 'Promo';
    let title = namespace + '_' + name;
    let resourceValue = this.resourceService.getViewResourceObject(title);
    return resourceValue;
  }

  letsChat() {
    this.letsChatClicked.emit();
    const rnWindow = window as any;
    if (rnWindow.ReactNativeWebView) {
      const message = JSON.stringify({ action: 'openChat', args: {} });
      rnWindow.ReactNativeWebView.postMessage(message);
    }

    // Show chat or not available dialog
    const chatHandler = new ChatHandler(this.matDialog, this.resourceService, this.utilityService, this.route, this.asappChatService);
    chatHandler.openChatInterface();
  }
}
